import { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { ErrorContext } from "../../../App";
import { calculateForecastWT } from "../../../api/sensorApi";
import moment from "moment";


function useFetchSensorLife(sensorID, start, end, forecastMonths) {
    const [lifeExpectancyInYears, setlifeExpectancyInYears] = useState();
    const errorContext = useContext(ErrorContext);
    const { showAlert } = errorContext

    useEffect(() => {
        calculateForecastWT({
            sensor_id: sensorID,
            selectedStartDate: moment(start).format("YYYY-MM-DD"),
            selectedEndDate: moment(end).format("YYYY-MM-DD"),
            forecastMonths: forecastMonths.value,
        })
        .then((result) => {
            if (result?.status === 'error') {
                showAlert(result?.errorMessage);
            }
            setlifeExpectancyInYears(+result?.data?.lifeExpectancyInYears + end.year());
        }).catch((error) => {
            console.log(error)
            toast.error("Error fetching sensor data")
        });
    }, [sensorID, start, end, forecastMonths, showAlert]);

    return { lifeExpectancyInYears }
}



export default useFetchSensorLife;